module.exports = __webpack_public_path__ + "media/img/clients/client4-d255a6e357d6ffaec4ee134026ce23df.svg";